<template>
  <dd-customer-page :customer-id="customer_id" header="Financiële Analyse">
    <!-- Replace the clickable dashboard-cards row with Ant Design Vue 2 tabs -->
    <template v-slot:tabs>
      <dd-tab-group value="test">
        <dd-tab key="scenarios" :disabled="!hasAdviesWidgetsScenariosKey">
          Kan ik blijven wonen?
        </dd-tab>
        <dd-tab key="refinance" :disabled="!hasAdviesWidgetsRefinanceKey">
          Oversluiten
        </dd-tab>
        <dd-tab key="maxMortgage" :disabled="!adviesWidgetsMaxMortgageKey">
          Verantwoorde maandlast
        </dd-tab>
        <dd-tab key="interestList" :disabled="!adviesWidgetsInterestListKey">
          Rentelijst
        </dd-tab>
        <dd-tab
          key="sustainability"
          :disabled="!adviesWidgetsSustainabilityKey"
        >
          Verduurzaming
        </dd-tab>
        <dd-tab
          key="deathInsurance"
          :disabled="!canUseTopicusCompareCalculators"
        >
          ORV vergelijken
        </dd-tab>
        <dd-tab key="carInsurance" :disabled="!canUseRollsCompareCalculators">
          Autoverzekering vergelijken
        </dd-tab>
        <dd-tab
          key="summary"
          :disabled="
            !(
              canUseTopicusCompareCalculators || canUseTopicusCompareCalculators
            )
          "
        >
          Vergelijkings samenvatting
        </dd-tab>
      </dd-tab-group>
    </template>
    <template v-slot:content>
      <dd-tab-content-wrapper>
        <dd-tab-content key="scenarios" id="scenarios">
          <ScenariosPage
            v-if="hasAdviesWidgetsScenariosKey"
            :customer-id="customer_id"
            :customer_info="customerInfo"
          />
          <p v-else>Niet beschikbaar.</p>
        </dd-tab-content>

        <dd-tab-content key="refinance" id="refinance">
          <RefinancePage
            v-if="hasAdviesWidgetsRefinanceKey"
            :customer-id="customer_id"
          ></RefinancePage>
          <p v-else>Niet beschikbaar.</p>
        </dd-tab-content>

        <dd-tab-content key="maxMortgage" id="maxMortgage">
          <AdviesWidget
            v-if="adviesWidgetsMaxMortgageKey"
            :api-base-url="adviesWidgetsApiBaseUrl"
            :api-key="adviesWidgetsMaxMortgageKey"
            :cdn-base-url="adviesWidgetsCdnBaseUrl"
            widget-constructor="MaximumMortgageWidget"
            widget-slug="max-mortgage"
            :state-setter="setMaximumMortgageState"
          ></AdviesWidget>
          <p v-else>Niet beschikbaar</p>
        </dd-tab-content>
        <dd-tab-content key="interestList" id="interestList">
          <AdviesWidget
            v-if="adviesWidgetsInterestListKey"
            :api-base-url="adviesWidgetsApiBaseUrl"
            :api-key="adviesWidgetsInterestListKey"
            :cdn-base-url="adviesWidgetsCdnBaseUrl"
            widget-constructor="InterestListWidget"
            widget-slug="interest-list"
          ></AdviesWidget>
          <p v-else>Niet beschikbaar</p>
        </dd-tab-content>
        <dd-tab-content key="sustainability" id="sustainability">
          <AdviesWidget
            v-if="adviesWidgetsSustainabilityKey"
            :api-base-url="adviesWidgetsApiBaseUrl"
            :api-key="adviesWidgetsSustainabilityKey"
            :cdn-base-url="adviesWidgetsCdnBaseUrl"
            widget-constructor="SustainabilityWidget"
            widget-slug="sustainability"
          ></AdviesWidget>
          <p v-else>Niet beschikbaar</p>
        </dd-tab-content>
        <dd-tab-content key="deathInsurance" id="deathInsurance">
          <death-insurance-page
            v-if="canUseRollsCompareCalculators"
            :customer-id="customer_id"
          />
          <p v-else>Niet beschikbaar</p>
        </dd-tab-content>
        <dd-tab-content key="carInsurance" id="carInsurance">
          <car-insurance-page
            v-if="canUseTopicusCompareCalculators"
            :customer-id="customer_id"
          />
          <p v-else>Niet beschikbaar</p>
        </dd-tab-content>
        <dd-tab-content key="summary" id="summary">
          <comparison-summary
            v-if="
              canUseRollsCompareCalculators || canUseTopicusCompareCalculators
            "
            :can-use-rolls-compare-calculators="canUseRollsCompareCalculators"
            :can-use-topicus-compare-calculators="
              canUseTopicusCompareCalculators
            "
            :customer-id="customer_id"
          />
          <p v-else>Niet beschikbaar</p>
        </dd-tab-content>
      </dd-tab-content-wrapper>
    </template>
  </dd-customer-page>
</template>

<script>
import analysisApi from "~/api/analysis";
import MortgageRefinance from "~/modules/compare/MortgageRefinance.vue";
import AdviesWidget from "~/pages/analysis/components/AdviesWidget.vue";
import ScenariosPage from "~/pages/analysis/components/ScenariosPage.vue";
import PaneComponent from "~/pages/insurance/index/components/PaneComponent.vue";
import RefinancePage from "~/pages/analysis/components/RefinancePage.vue";
import CarInsurancePage from "~/pages/analysis/components/CarInsurancePage.vue";
import DeathInsurancePage from "~/pages/analysis/components/DeathInsurancePage.vue";
import stateSetters from "~/pages/analysis/components/stateSetters";

export default {
  name: "CustomerAnalysisPage",
  props: {
    //
  },
  components: {
    PaneComponent,
    MortgageRefinance,
    AdviesWidget,
    ScenariosPage,
    RefinancePage,
    CarInsurancePage,
    DeathInsurancePage,
  },
  mixins: [stateSetters],
  data() {
    return {
      // Default active tab:
      page: "livable",
      // Map of pages (optional, but keeps a reference if needed)
      pages: {
        maximumMortgage: "maximumMortgage",
        interestRates: "interestRates",
        livable: "livable",
        refinance: "refinance",
        deathInsurance: "deathInsurance",
        carInsurance: "carInsurance",
        comparisonSummary: "comparisonSummary",
      },
      customerInfo: {
        name: "",
        birthDay: "",
      },
      partnerInfo: {
        name: "",
        birthDay: "",
      },
      canUseTopicusCompareCalculators: null,
      canUseRollsCompareCalculators: null,
      adviesWidgetsInterestListKey: null,
      adviesWidgetsSustainabilityKey: null,
      adviesWidgetsMaxMortgageKey: null,
      adviesWidgetsApiBaseUrl: null,
      adviesWidgetsCdnBaseUrl: null,
      hasAdviesWidgetsRefinanceKey: false,
      hasAdviesWidgetsScenariosKey: false,
    };
  },
  async mounted() {
    let response = await analysisApi.getIndex();

    this.canUseTopicusCompareCalculators =
      response.canUseTopicusCompareCalculators;
    this.canUseRollsCompareCalculators = response.canUseRollsCompareCalculators;
    this.adviesWidgetsInterestListKey = response.adviesWidgetsInterestListKey;
    this.adviesWidgetsSustainabilityKey =
      response.adviesWidgetsSustainabilityKey;
    this.adviesWidgetsMaxMortgageKey = response.adviesWidgetsMaxMortgageKey;
    this.hasAdviesWidgetsRefinanceKey = response.hasAdviesWidgetsRefinanceKey;
    this.hasAdviesWidgetsScenariosKey = response.hasAdviesWidgetsScenariosKey;
    this.adviesWidgetsCdnBaseUrl = response.adviesWidgetsCdnBaseUrl;
    this.adviesWidgetsApiBaseUrl = response.adviesWidgetsApiBaseUrl;
  },
  computed: {
    customer_id() {
      return this.$route.params.customerId;
    },
  },
};
</script>

<style>
.tab {
  white-space: nowrap
}
</style>
